import { Group, Stack, Text, Title } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";

export function SystemEmailsHeader() {
  return (
    <Stack gap={4}>
      <Group gap="sm">
        <IconMail size={28} />
        <Title order={1}>System Emails</Title>
      </Group>
      <Text c="dimmed">
        See every email the system sends, its subject, and exactly when it is
        triggered.
      </Text>
    </Stack>
  );
}
